// Polish-aware slug helper. Kept dependency-free and framework-free (no JSX, no imports) so the
// exact same module can be pulled in two very different ways:
//  - by the app (Vite/SWC) for building/matching /kierunek/:destinationSlug URLs
//  - by the api/sitemap.js Vercel serverless function, run directly under plain Node, for the
//    same slug used in the sitemap's <url> entries
// There is no "slug" field on the destinations catalog API, so this is the single source of
// truth for turning a destination name into a URL segment - every consumer must use it rather
// than rolling its own lowercase/replace logic, or the two would drift apart.
const POLISH_DIACRITICS = {
  ą: "a", ć: "c", ę: "e", ł: "l", ń: "n", ó: "o", ś: "s", ź: "z", ż: "z",
  Ą: "a", Ć: "c", Ę: "e", Ł: "l", Ń: "n", Ó: "o", Ś: "s", Ź: "z", Ż: "z",
};

export function slugify(value) {
  if (!value) return "";
  const withoutPolishDiacritics = String(value)
    .split("")
    .map((ch) => POLISH_DIACRITICS[ch] ?? ch)
    .join("");
  return withoutPolishDiacritics
    .normalize("NFKD")
    .replace(/[̀-ͯ]/g, "") // strip remaining accents (é, ü, ...) via unicode decomposition
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function getDestinationSlug(destination) {
  return slugify(destination?.name);
}
